import ImageBlobReduce from 'image-blob-reduce';
const reduce = new ImageBlobReduce();
const MAX_IMAGE_SIZE = 1000;
function optimizeImage(file, maxDimension = MAX_IMAGE_SIZE) {
    return reduce.toBlob(file, { max: maxDimension });
}
export { optimizeImage };
